import { Component, computed, HostBinding, input } from '@angular/core';
import { AuthenticatorService } from '@aws-amplify/ui-angular';

@Component({
  selector: 'nem-layout',
  templateUrl: './main-layout.comp.html',
  standalone: false
})
export class MainLayoutComponent {
  @HostBinding('class') classname = 'flex flex-col h-full w-full overflow-hidden bg-slate-50';

  topSlot = input<boolean>(true);
  contentWithScroll = input<boolean>(true);
  gridColumns = input<boolean | number>(true);
  customContentClass = input<string[]>([]);

  constructor(private _authenticator: AuthenticatorService) {}

  get authenticated(): boolean {
    return this._authenticator.authStatus === 'authenticated';
  }

  contentClass = computed(() => {
    const base = ['p-6', 'grid', 'gap-6', 'pb-24'];
    const cols = this.gridColumns();

    if (cols) {
      base.push(`xl:grid-cols-${typeof cols === 'number' ? cols : 2}`);
    } else {
      base.push('xl:grid-cols-1');
    }

    return [...base, ...this.customContentClass()].join(' ');
  });
}
